import tonStyles from './../ton.json'

export default {
  color: tonStyles.colors.SecondaryGrey
}
